<template>
  <v-row>
    <v-col
      v-if="showMilitaryDocumentSelector"
      :lg="12"
      :sm="12"
      :md="12"
      class="mb-3"
    >
      <v-autocomplete
        v-model="selectedMilitaryDocument"
        :items="militaryDocumentOptions"
        item-text="label"
        item-value="key"
        label="Documento Militar"
        hint="Selecione o documento militar que deseja enviar"
        persistent-hint
        outlined
        dense
      />
    </v-col>
    <v-col
      v-for="(doc, index) in documentosFaltando"
      :key="doc.tipoDocumento"
      :lg="12"
      :sm="12"
      :md="12"
      class="mb-3"
    >
      <v-form
        :ref="`FORM_${doc.tipoDocumento}`"
        lazy-validation
        class="app-form"
        @submit.prevent="onSubmit(doc)"
      >
        <AppCard>
          <template #header>
            {{
              typeSolicitation === "RENOVACAO_CADASTRO_TRANSPORTADORA" &&
                doc.tipoDocumento === "REQUERIMENTO_TRANSPORTADORA_ASSINADO"
                ? "Requerimento ou apresentar contrato social se sociedade comercial EPP, ou no caso de sociedade por ações  ME"
                : tipoDocumento[`${doc.tipoDocumento}`]
            }}
          </template>
          <template #content>
            <v-row no-gutters>
              <!-- <v-col
                v-if="doc.tipoDocumento === 'CERTIDAO_REGULAR_DA_ARCE'"
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3"
              >
                <v-text-field
                  v-model="doc.codigo"
                  outlined
                  label="Codigo *"
                  placeholder="Ex:. 31232876"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col> -->
              <!-- Cópia da CRLV -->
              <v-col
                v-if="
                  ['CERTIDAO_REGULAR_DA_ARCE', 'COPIA_CRLV'].includes(
                    doc.tipoDocumento
                  )
                "
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3"
              >
                <v-text-field
                  v-model="doc.numeroComplemento"
                  outlined
                  :label="
                    doc.tipoDocumento === 'COPIA_CRLV'
                      ? 'Renavan *'
                      : 'Código validador *'
                  "
                  placeholder="Ex:. 31232876"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>

              <v-col
                v-if="doc.tipoDocumento === 'COPIA_CRLV'"
                :lg="6"
                :sm="12"
                :md="6"
                class="pr-2 pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                    rules.datePast,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="doc.tipoDocumento === 'COPIA_CRLV'"
                :lg="6"
                :sm="12"
                :md="6"
                class="pl-2 pb-0"
              >
                <v-text-field
                  v-model="doc.dataValidade"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Validade (Licenciamento) *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.datePast,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <!--/ Cópia da CRLV -->

              <!-- Apólice -->
              <v-col
                v-if="
                  doc.tipoDocumento ===
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.orgaoExpedidor"
                  outlined
                  label="Seguradora *"
                  placeholder="Ex:. Porto Seguro"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  doc.tipoDocumento ===
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="mt-3 pl-1"
              >
                <v-text-field
                  v-model="doc.numeroComplemento"
                  v-mask="'########################'"
                  outlined
                  label="Número Apólice *"
                  placeholder="Ex:. 31232876"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  doc.tipoDocumento ===
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
                "
                :lg="6"
                :sm="12"
                :md="6"
                class="pr-1 pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  doc.tipoDocumento ===
                    'APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA'
                "
                :lg="6"
                :sm="12"
                :md="6"
                class="pl-1 pb-0"
              >
                <v-text-field
                  v-model="doc.dataValidade"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Validade *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[rules.required, rules.date]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <!--/ Apólice -->

              <!-- Laudo Técnico -->
              <v-col
                v-if="doc.tipoDocumento === 'LAUDO_TECNICO'"
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.orgaoExpedidor"
                  outlined
                  label="Profissional/Empresa Responsável *"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>

              <v-col
                v-if="doc.tipoDocumento === 'LAUDO_TECNICO'"
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.numeroComplemento"
                  outlined
                  label="Número da ART *"
                  placeholder="Ex:. 31232876"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>

              <v-col
                v-if="doc.tipoDocumento === 'LAUDO_TECNICO'"
                :lg="6"
                :sm="12"
                :md="6"
                class="pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>

              <v-col
                v-if="doc.tipoDocumento === 'LAUDO_TECNICO'"
                :lg="6"
                :sm="12"
                :md="6"
                class="pb-0 pl-2"
              >
                <v-text-field
                  v-model="doc.dataValidade"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Validade *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[rules.required, rules.date]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <!--/ Laudo Técnico -->

              <!-- ART -->
              <v-col
                v-if="doc.tipoDocumento === 'ART'"
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.numeroComplemento"
                  outlined
                  label="Número da ART *"
                  placeholder="Ex:. 31232876"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="doc.tipoDocumento === 'ART'"
                :lg="12"
                :sm="12"
                :md="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <!--/ ART -->

              <!-- DOCUMENTOS PARA RENOVAÇÃO EMPRESA -->
              <v-col
                v-if="
                  hasDocumentForCompany(doc.tipoDocumento) &&
                    doc.tipoDocumento !==
                    'REQUERIMENTO_TRANSPORTADORA_ASSINADO' &&
                    doc.tipoDocumento !== 'CERTIDAO_REGULAR_DA_ARCE'
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="pr-2 pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  hasDocumentForCompany(doc.tipoDocumento) &&
                    doc.tipoDocumento !==
                    'REQUERIMENTO_TRANSPORTADORA_ASSINADO' &&
                    doc.tipoDocumento !== 'CERTIDAO_REGULAR_DA_ARCE'
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="pb-0"
              >
                <v-text-field
                  v-model="doc.dataValidade"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Validade *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[rules.required, rules.date]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  (doc.tipoDocumento === 'APOLICE_SEGURO' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_ARCE' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_DISTRIBUIDOR' ||
                    doc.tipoDocumento === 'CERTIDAO_INEXISTENCIA_DEBITO') &&
                    !['SUBSTITUICAO_COOPERADO'].includes(typeSolicitation)
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="pb-0"
              >
                <v-text-field
                  v-model="doc.dataEmissao"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Emissão *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[
                    rules.required,
                    rules.date,
                    rules.datePast,
                    rules.dateFuture,
                  ]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  (doc.tipoDocumento === 'APOLICE_SEGURO' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_ARCE' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_DISTRIBUIDOR' ||
                    doc.tipoDocumento === 'CERTIDAO_INEXISTENCIA_DEBITO') &&
                    !['SUBSTITUICAO_COOPERADO'].includes(typeSolicitation)
                "
                :lg="6"
                :sm="6"
                :md="6"
                class="pb-0"
              >
                <v-text-field
                  v-model="doc.dataValidade"
                  v-mask="'##/##/####'"
                  outlined
                  label="Data Validade *"
                  placeholder="Ex:. 13/03/2020"
                  :rules="[rules.required, rules.date]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  ( doc.tipoDocumento === 'APOLICE_SEGURO' ||
                    doc.tipoDocumento === 'BALANCO_PATRIMONIAL' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_ARCE' ||
                    doc.tipoDocumento === 'CERTIDAO_NEGATIVA_DISTRIBUIDOR' ||
                    doc.tipoDocumento === 'CERTIDAO_INEXISTENCIA_DEBITO') &&
                    !['SUBSTITUICAO_COOPERADO'].includes(typeSolicitation)
                "
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.orgaoExpedidor"
                  outlined
                  label="Profissional/Empresa Responsável *"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <v-col
                v-if="
                  hasDocumentForCompany(doc.tipoDocumento) &&
                    (doc.tipoDocumento === 'CERTIDAO_NEGATIVA_FALENCIA' ||
                      doc.tipoDocumento ===
                      'APOLICE_SEGURO_RESPONSABILIDADE_CIVIL')
                "
                :lg="12"
                :sm="12"
                :md="12"
                class="mt-3 pr-1"
              >
                <v-text-field
                  v-model="doc.orgaoExpedidor"
                  outlined
                  label="Profissional/Empresa Responsável *"
                  :rules="[rules.required]"
                  dense
                  :disabled="doc.uploaded"
                />
              </v-col>
              <!--/ DOCUMENTOS PARA RENOVAÇÃO EMPRESA -->

              <v-col
                :lg="12"
                :sm="12"
                :md="12"
              >
                <v-divider class="mb-6" />

                <v-alert
                  v-if="doc.tipoDocumento === 'COPIA_CRLV'"
                  dense
                  type="warning"
                  outlined
                >
                  <strong>Atenção</strong>
                  <br>
                  Caso o proprietário do veículo for diferente da
                  transportadora, enviar o Contrato Social e Contrato de Cessão
                  junto à CRLV.
                </v-alert>

                <Upload
                  v-if="!doc.uploaded"
                  v-model="doc.file"
                  :name-input="index"
                  :accept-img="documentsAceptedImg.includes(doc.tipoDocumento)"
                  @change="addDocument(doc)"
                />
                <v-file-input
                  v-if="!doc.uploaded"
                  v-model="doc.file"
                  class="inputfile-custom"
                  accept="application/pdf"
                  truncate-length="15"
                  :rules="[rules.required]"
                />
                <v-list
                  v-if="doc.file"
                  subheader
                  two-line
                >
                  <v-list-item
                    :key="`${index}-list-documents`"
                    :dense="true"
                    :selectable="true"
                  >
                    <v-list-item-avatar>
                      <v-icon
                        class="red darken-2"
                        dark
                        style="color: #fff !important"
                      >
                        {{
                          documentsAceptedImg.includes(doc.tipoDocumento)
                            ? "image"
                            : "picture_as_pdf"
                        }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="doc.filename" />
                      <v-list-item-subtitle
                        v-text="
                          `Tipo: ${doc.type} Tamanho: ${fileSize(doc.size)}`
                        "
                      />
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        v-if="doc.uploaded"
                        size="24"
                        color="#78e5d5"
                      >
                        check_circle
                      </v-icon>
                      <v-icon
                        v-if="doc.error"
                        size="24"
                        color="#e57878"
                      >
                        info
                      </v-icon>
                      <v-progress-circular
                        v-if="!doc.error && !doc.uploaded && doc.progress > 0"
                        size="21"
                        :width="3"
                        :value="doc.progress"
                      />
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </template>
          <template #footer>
            <v-btn
              v-if="!doc.uploaded"
              color="primary"
              depressed
              class="ml-2 mb-2"
              type="submit"
            >
              Enviar
            </v-btn>
          </template>
        </AppCard>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { TipoDocumento } from "@/models/sit-pedido/tipo-documento.enum";
import { mapActions, mapState } from "vuex";
import Upload from "./Upload";
import GlobalStore from "@/store/modules/global";
import AppCard from "@/components/AppCard";

import { fileSize } from "@/util/format-file";

import dayjs from "dayjs";

// Vuex Store - Sit Pedidos (mapping actions and states)
const actions = mapActions("sitPedidos", [
  "setFormIsLoading",
  "setFormDocuments",
  "setFormDocument",
  "clearForm",
]);
const state = mapState("sitPedidos", ["form", "detail"]);

import axios from "axios";
import { VUE_APP_SIT_PEDIDOS_API_URL } from "@/commons/config";
const api = axios.create({ baseURL: VUE_APP_SIT_PEDIDOS_API_URL });

import TransportadoraAuth from "@/services/transportadora.auth.service";

import { TipoDocumentoPorTipoPedido } from "@/models/sit-pedido/tipo-documento.enum";
import { TipoDocumentoEnum } from "@/store/modules/renovacao-crlv";

export default {
  name: "DocumentosForm",

  components: {
    Upload,
    AppCard,
  },

  props: {
    typeSolicitation: {
      type: String,
      required: true,
    },
    resourceId: {
      type: Number,
      required: true,
    },
    sexo: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    tipoDocumento: TipoDocumento,
    documentsValids: false,
    selectedMilitaryDocument: null,
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",

      date: function (value) {
        return !!dayjs(value, "DD/MM/YYYY", true).isValid() || "Data inválida";
      },

      dateFuture: function (value) {
        return (
          !dayjs(value, "DD/MM/YYYY", true).isAfter(dayjs()) ||
          "Data está no futuro"
        );
      },

      datePast: function (value) {
        const datePastLimit = dayjs().subtract(100, "year");
        return (
          !dayjs(value, "DD/MM/YYYY", true).isBefore(datePastLimit) ||
          "Data muito antiga"
        );
      },

      // lessThanIssuanceDate: function(value) {
      //   return !dayjs(value, 'DD/MM/YYYY', true).isBefore(dayjs()) || "Data é menor que a data de emissão"
      // },
    },

    documentTypeForRenovationCompany: TipoDocumentoPorTipoPedido.filter(
      (td) => td.tipoPedido === "RENOVACAO_CADASTRO_TRANSPORTADORA"
    )[0].documentos,
    documentsAceptedImg: [
      TipoDocumentoEnum.FOTO_DA_FRENTE_DO_VEICULO,
      TipoDocumentoEnum.FOTO_DA_TRASEIRA_DO_VEICULO,
      TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA,
      TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS,
      TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS,
      TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS,
      TipoDocumentoEnum.FOTO_CHASSI,
    ],
  }),

  computed: {
    ...state,

    isDetailRoute() {
      return this.$route.name === "pedidos-detail";
    },

    isSubstituicaoCooperado() {
      return this.typeSolicitation === "SUBSTITUICAO_COOPERADO";
    },

    isMasculino() {
      const sexo = `${this.sexo || ""}`.trim().toUpperCase();
      return ["M", "MASCULINO"].includes(sexo);
    },

    hasSexoInformado() {
      return !!`${this.sexo || ""}`.trim();
    },

    militaryDocumentTypes() {
      return [
        TipoDocumentoEnum.CARTEIRA_RESERVISTA,
        TipoDocumentoEnum.COMPROVANTE_SERVICO_MILITAR,
      ];
    },

    militaryDocumentOptions() {
      return this.tipoDocumentoPorTipoPedido.documentos
        .filter((doc) => this.militaryDocumentTypes.includes(doc.tipoDocumento))
        .map((doc) => ({
          key: doc.tipoDocumento,
          label: this.tipoDocumento[doc.tipoDocumento],
        }));
    },

    uploadedMilitaryDocumentTypes() {
      if (!this.isSubstituicaoCooperado) {
        return [];
      }

      if (this.isDetailRoute) {
        return (this.detail?.data?.documentosAnexos || [])
          .filter((doc) => this.militaryDocumentTypes.includes(doc.tipoDocumento))
          .map((doc) => doc.tipoDocumento);
      }

      return (this.form.documents || [])
        .filter(
          (doc) =>
            this.militaryDocumentTypes.includes(doc.tipoDocumento) && doc.uploaded
        )
        .map((doc) => doc.tipoDocumento);
    },

    shouldRequireMilitaryDocument() {
      if (!this.isDetailRoute || !this.isSubstituicaoCooperado) {
        return false;
      }

      return this.hasSexoInformado && this.isMasculino;
    },

    showMilitaryDocumentSelector() {
      return (
        this.shouldRequireMilitaryDocument &&
        this.uploadedMilitaryDocumentTypes.length === 0
      );
    },

    documentosFaltando: {
      get: function () {
        let documents = [];

        if (this.isDetailRoute) {
          if (!this.form.documents) {
            return [];
          }

          const documentosAnexos = this.detail?.data?.documentosAnexos || [];

          documents = this.form.documents.filter(
            (d) =>
              !documentosAnexos.find(
                (da) => da.tipoDocumento === d.tipoDocumento
              )
          );
        } else {
          documents = this.form.documents || [];
        }

        const documentosVisiveis = documents.filter(
          (documento) => !this.shouldHideDocument(documento.tipoDocumento)
        );

        if (!this.selectedMilitaryDocument) {
          return documentosVisiveis;
        }

        const indexSelecionado = documentosVisiveis.findIndex(
          (documento) => documento.tipoDocumento === this.selectedMilitaryDocument
        );

        if (indexSelecionado <= 0) {
          return documentosVisiveis;
        }

        const [documentoMilitar] = documentosVisiveis.splice(indexSelecionado, 1);
        documentosVisiveis.unshift(documentoMilitar);

        return documentosVisiveis;
      },
      set: function (doc) {},
    },

    currentToken: {
      get: () => TransportadoraAuth.token,
    },

    tipoDocumentoPorTipoPedido: {
      get: function () {
        return TipoDocumentoPorTipoPedido.find(
          (d) => d.tipoPedido === this.typeSolicitation
        );
      },
    },
  },
  watch: {
    showMilitaryDocumentSelector: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.selectedMilitaryDocument = null;
          return;
        }

        if (
          this.selectedMilitaryDocument &&
          this.militaryDocumentTypes.includes(this.selectedMilitaryDocument)
        ) {
          return;
        }

        const documentWithFile = (this.form.documents || []).find(
          (doc) =>
            this.militaryDocumentTypes.includes(doc.tipoDocumento) && !!doc.file
        );

        this.selectedMilitaryDocument = documentWithFile
          ? documentWithFile.tipoDocumento
          : this.militaryDocumentOptions[0]?.key || null;
      },
    },
    selectedMilitaryDocument(next, prev) {
      if (!prev || next === prev) {
        return;
      }

      this.resetMilitaryDocument(prev);
    },
  },

  destroyed() {
    this.clearForm();
  },

  mounted() {
    this.setFormDocuments(
      this.verificaTipoServico(this.tipoDocumentoPorTipoPedido.documentos)
    );
  },

  methods: {
    ...actions,

    shouldHideDocument(tipoDocumento) {
      if (
        !this.isSubstituicaoCooperado ||
        !this.militaryDocumentTypes.includes(tipoDocumento)
      ) {
        return false;
      }

      if (!this.shouldRequireMilitaryDocument) {
        return true;
      }

      if (!this.showMilitaryDocumentSelector) {
        return true;
      }

      return this.selectedMilitaryDocument !== tipoDocumento;
    },

    resetMilitaryDocument(tipoDocumento) {
      const baseDocument = this.tipoDocumentoPorTipoPedido.documentos.find(
        (doc) => doc.tipoDocumento === tipoDocumento
      );

      if (!baseDocument) {
        return;
      }

      this.setFormDocument({
        tipoDocumento,
        doc: { ...baseDocument },
      });
    },

    hasDocumentForCompany(document) {
      if (
        this.documentTypeForRenovationCompany.some(
          (td) => td.tipoDocumento === document
        )
      )
        return true;

      return false;
    },

    fileSize(v) {
      return fileSize(v);
    },

    addDocument(doc) {
      const file = {
        file: doc.file,
        filename: doc.file.name,
        type: doc.file.type,
        size: doc.file.size,
        error: false,
        progress: 0,
        uploaded: false,
      };
      const document = { ...doc, ...file };
      this.setFormDocument({ tipoDocumento: doc.tipoDocumento, doc: document });
    },

    async onSubmit(doc) {
      const formRef = `FORM_${doc.tipoDocumento}`;

      const isValid = this.$refs[formRef][0].validate();

      if (isValid) {
        await this.onUpload(doc);
      }
    },

    async onUpload(doc) {
      this.setFormDocument({
        tipoDocumento: doc.tipoDocumento,
        doc: { progress: 0, error: false },
      });
      try {
        let formData = new FormData();

        const dataEmissao = doc.dataEmissao
          ? dayjs(`${doc.dataEmissao}`, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "";
        const dataValidade = doc.dataValidade
          ? dayjs(`${doc.dataValidade}`, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "";

        formData.append("file", doc.file);
        formData.append("tipoDocumento", `${doc.tipoDocumento}`);
        formData.append("dataEmissao", `${dataEmissao}`);
        formData.append("dataValidade", `${dataValidade}`);
        formData.append("orgaoExpedidor", `${doc.orgaoExpedidor}`);
        formData.append("numeroComplemento", `${doc.numeroComplemento}`);

        const url =
          this.typeSolicitation === "CADASTRO_TRANSPORTADORA"
            ? `/api/pedidos/transportadora/${this.resourceId}/upload-arquivo-transportadora`
            : `/api/pedidos/${this.resourceId}/upload-arquivo`;

        const { data } = await api.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.currentToken}`,
          },
          onUploadProgress: ({ total, loaded }) => {
            const percentage = Math.round((loaded * 100) / total);
            this.setFormDocument({
              tipoDocumento: doc.tipoDocumento,
              doc: { progress: percentage },
            });
          },
        });

        this.setFormDocument({
          tipoDocumento: doc.tipoDocumento,
          doc: { id: data.id, uploaded: true, error: false },
        });
        this.$emit("uploaded", true);
      } catch (error) {
        this.setFormDocument({
          tipoDocumento: doc.tipoDocumento,
          doc: { uploaded: false, error: true },
        });
        let message = null;
        if (error.response) {
          const { data } = error.response;
          message = data.error ? data.error : data.message;
        } else {
          message = error;
        }
        GlobalStore.setSnackBar({
          message,
          type: "error",
          show: true,
          timeout: 5000,
          color: "error",
        });
      }
    },

    _dateIsValid(date) {
      return dayjs(date, "DD-MM-YYYY", true).isValid();
    },
    verificaTipoServico(docs) {
      if (this.form.pedido != null) {
        //remover depois
        if (this.form.pedido.tipoPedido === "CADASTRO_TRANSPORTADORA") {
          const { tipoServico } = this.form.pedido;
          if (tipoServico.length > 1) {
            return this.tipoDocumentoPorTipoPedido.documentos;
          }
          if (tipoServico[0].id == 2) {
            // COMPLEMENTAR;
            return docs.filter((docs) => docs.complementar === true);
          }
          if (tipoServico[0].id == 3) {
            // FRETAMENTO;
            return docs.filter((docs) => docs.fretamento === true);
          } else {
            return this.tipoDocumentoPorTipoPedido.documentos;
          }
        } else {
          return this.tipoDocumentoPorTipoPedido.documentos;
        }
      } else {
        //remover depois
        return this.tipoDocumentoPorTipoPedido.documentos;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500 !important;
}
.v-divider {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
